import { render, staticRenderFns } from "./EsportaDati.vue?vue&type=template&id=91a00f9e"
import script from "./EsportaDati.vue?vue&type=script&lang=js"
export * from "./EsportaDati.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports